import { render, staticRenderFns } from "./VipServiceEditView.vue?vue&type=template&id=47169046&scoped=true"
import script from "./VipServiceEditView.vue?vue&type=script&lang=js"
export * from "./VipServiceEditView.vue?vue&type=script&lang=js"
import style0 from "./VipServiceEditView.vue?vue&type=style&index=0&id=47169046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47169046",
  null
  
)

export default component.exports